module.exports = __webpack_public_path__ + "static/img/middleTable.3ceebe5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cockpitCh/middleTable.png
// module id = n7Nj
// module chunks = 31